import PrimaryPalette from '../../colors';

export const TabsTheme = {
  default: {
    arrowBackground: PrimaryPalette.white,
    arrowColor: PrimaryPalette.mediumEvergreen,
  },
  hover: {
    arrowHighlight: PrimaryPalette.extraLightIris,
  },
};
